import React from "react";
import { Button, Popconfirm, message } from "antd";
import { useMutation } from "@apollo/react-hooks";
import { gql } from "apollo-boost";

const DELETE_USER_MUTATION = gql`
  mutation deleteUser($id: ID!) {
    deleteUser(id: $id)
  }
`;

const DeleteClientButton = ({ id, size = "small", onDeleteSuccess }) => {
  const [deleteUser, { loading }] = useMutation(DELETE_USER_MUTATION);
  const confirm = () => {
    deleteUser({
      variables: { id },
    })
      .then(() => {
        message.success("Client has been deleted");
        onDeleteSuccess();
      })
      .catch((err) => {
        message.error("An error!");
      });
  };
  return (
    <Popconfirm
      title={
        <div>
          <p>Are you sure delete this client?</p>
        </div>
      }
      onConfirm={confirm}
      onCancel={() => {}}
      okText="Yes"
      cancelText="No"
      okType={"danger"}
    >
      <Button loading={loading} type={"danger"} size={size}>
        Delete
      </Button>
    </Popconfirm>
  );
};

export default DeleteClientButton;
